import { render, staticRenderFns } from "./SeeAllTestsPage.vue?vue&type=template&id=264c5736&scoped=true&"
import script from "./SeeAllTestsPage.vue?vue&type=script&lang=js&"
export * from "./SeeAllTestsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264c5736",
  null
  
)

export default component.exports